<template>
    <div class="base-paginacao">
        <div class="total">
            <span>{{ total }} {{ $t('mensagens.paginacao.resultados') }}</span>
            <div style="margin: 0 20px"></div>
            <span>{{ $t('mensagens.paginacao.visualizacoesPorPagina') }}:</span>
            <el-pagination
                :current-page="page"
                :page-sizes="pageSizes"
                :page-size="size"
                layout="sizes"
                :total="total"
                @size-change="handleSizeChange"
            />
        </div>
        <div class="prev_next">
            <el-pagination
                :current-page="page"
                :page-sizes="pageSizes"
                :page-size="size"
                layout="prev, pager, next, jumper"
                :total="total"
                @current-change="handleCurrentChange"
            />
        </div>
    </div>
</template>

<script>
/**
 * Paginação padrão das listagens, no mesmo formato usado no módulo warehouse:
 * à esquerda o total de resultados e o seletor de itens por página, à direita
 * os controles de navegação.
 *
 * A página é 1-based (como o el-pagination). Converta para o índice da API com `page - 1`.
 *
 * Uso:
 *   BasePaginacao(
 *       :page.sync='paginacao.page',
 *       :size.sync='paginacao.size',
 *       :total='totalResultados',
 *       @alterar='carregar'
 *   )
 */
export default {
    name: 'BasePaginacao',
    props: {
        page: {
            type: Number,
            required: true
        },
        size: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        pageSizes: {
            type: Array,
            required: false,
            default: () => [10, 20, 30, 40]
        }
    },
    methods: {
        handleSizeChange(size) {
            this.$emit('update:page', 1);
            this.$emit('update:size', size);
            this.$emit('alterar');
        },
        handleCurrentChange(page) {
            this.$emit('update:page', page);
            this.$emit('alterar');
        }
    }
};
</script>

<style scoped lang="scss">
.base-paginacao {
    display: grid;
    grid-template-columns: 2fr auto;
    margin: 20px 12px 0;
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }

    .total {
        display: flex;
        align-items: center;
        @media (max-width: 768px) {
            flex-direction: column;
        }
    }

    .prev_next {
        display: flex;
        @media (max-width: 768px) {
            justify-content: center;
            margin-top: 20px;
        }
    }
}
</style>
